import {
  RecruitMenu,
  RecruitDetail,
  RecruitRow,
  RecruitStatus,
} from "components/atoms/recruit"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import type { Recruit } from "interfaces/RecruitIF"

interface RecruitProp {
  recruit: Recruit
}

export const RecruitItem: React.FC<RecruitProp> = ({
  children,
  recruit,
  ...props
}) => {
  return (
    <>
      <RecruitRow {...props}>
        <RecruitLink to={"/recruit/" + recruit.recruitId + "/show"}>
          <RecruitDetail
            title={recruit.title}
            description={recruit.description}
          />
          <RecruitStatus
            isApproved={recruit.isApproved}
            isPublished={recruit.isPublished}
          />
        </RecruitLink>
        <RecruitMenu recruit={recruit} />
      </RecruitRow>
      {children}
    </>
  )
}

const RecruitLink = styled(Link)`
  width: 100%;
  display: flex;
  align-items: center;
`
